// A guide's "Shop this guide" block: the bold heading followed by a list of
// product links. Shared by the article page, the build's Get the Look body and
// /tools-data/look-picks.json, so they all read the same picks.

export const SHOP_THIS_GUIDE_BLOCK =
  /(^|\n)\*\*Shop this guide\*\*[ \t]*\n(?:[ \t]*\n)?(?:[ \t]*-[ \t]+\[[^\]\n]+\]\(\/product\/[^)\s]+\)[ \t]*(?:\n|$))+/;

/** Product handles listed in a guide body's "Shop this guide" block, in order. */
export function shopThisGuideHandles(body) {
  const block = String(body ?? "").match(SHOP_THIS_GUIDE_BLOCK)?.[0] ?? "";
  return Array.from(block.matchAll(/\(\/product\/([^)\s]+)\)/g), (match) => match[1]);
}
